module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/design-3b417e6440b54a805121df83e6438b47.svg";